import { StoreDispatch } from '~/redux/store';
import { useDispatch } from 'react-redux';

export const useCobuDispatch: () => StoreDispatch = useDispatch;
